<script>
import * as VueGoogleMaps from 'vue2-google-maps';
import {queryString} from '../../mixins/querystring'

export default {
    mixins: [queryString],
    components: {
        'vue-google-autocomplete': VueGoogleMaps.Autocomplete,
    },
    data() {
        return {
            showSportDropdown: false,
            coords: [],
            sports: [],
            sport: null,
            address: null,
            filters: {
                languages: [],
                latitude: 0,
                longitude: 0,
                sport: null,
                municipality: null,
                countries: ['IT']
            }
        }
    },
    watch: {
        sport(val) {
            this.getSports()
        }
    },
    mounted() {
        this.getLocation()
        this.getSports()

        window.addEventListener('mouseup', (e) => {
            let el = document.getElementById('what-field')
            if (!this.isDescendant(el, e.target)) {
                this.$set(this, 'showSportDropdown', false)
            }
        }, true)
    },
    methods: {
        updateFormData() {
            let params = this.getAllUrlParams()

            for (let prop in params) {
                if (this.filters.hasOwnProperty(prop)) {
                    this.$set(this.filters, prop, params[prop])
                }
            }

            if (params.hasOwnProperty('sport')) {
                this.$set(this, 'sport', params.sport)
            }
        },
        isDescendant(parent, child) {
            let node = child.parentNode
            while (node != null) {
                if (node == parent) {
                    return true
                }
                node = node.parentNode
            }
            return false
        },
        setSport(sport) {
            this.$set(this.filters, 'sport', sport.name)
            this.$set(this, 'sport', sport.name)
            this.$set(this, 'showSportDropdown', false)
        },
        getSports() {
            let term = this.sport
            let source = route('api.sports.filter')

            if (!_.isEmpty(term)) {
                source = `${source}?term=${term}`
            }

            axios({
                method: 'get',
                url: source,
            }).then((response) => {
                this.$set(this.filters, 'sport', term)
                this.$set(this, 'sports', _.take(response.data.sports, 5))
            })
        },
        onSportFocus() {
            this.$set(this, 'showSportDropdown', true)
        },
        onSubmit() {
            if (_.isEmpty(this.filters.municipality)) {
                this.getLocation()
            }
            this.$emit('update-filters', this.filters)
        },
        changeAddress(e) {
            if (e.target.value.length == 0) {
                this.clearAddress()
            }
        },
        setPlace(place) {
            if (place) {
                let components = place.address_components
                let country = _.head(components.filter(i => {
                    return i.types.includes('country')
                }))
                let municipality = _.head(components.filter(i => {
                    return i.types.includes('locality')
                }))

                this.coords = [];
                this.coords.push(place.geometry.location.lat());
                this.coords.push(place.geometry.location.lng());

                this.$set(this.filters, 'latitude', place.geometry.location.lat())
                this.$set(this.filters, 'longitude', place.geometry.location.lng())
                this.$set(this.filters, 'municipality', municipality.long_name);
                this.$set(this.filters, 'countries', [country.short_name])
            }
        },
        clearAddress() {
            this.$set(this.filters, 'municipality', null)
            this.$set(this.filters, 'countries', ['IT'])
            this.$set(this.filters, 'latitude', 0)
            this.$set(this.filters, 'longitude', 0)
        },
        getLocation() {
            this.updateFormData()

            if (navigator.geolocation) {
                navigator
                    .geolocation
                    .getCurrentPosition(
                        this.returnPosition,
                        this.errorPosition
                    );
            }
        },
        returnPosition(position) {
            if (_.isEmpty(this.filters.municipality)) {
                this.$set(this.filters, 'latitude', position.coords.latitude)
                this.$set(this.filters, 'longitude', position.coords.longitude)
            }
            this.$emit('update-filters', this.filters)
        },
        errorPosition(error) {
            this.$emit('update-filters', this.filters)
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/summer-camps/SummerCampSearchBar.vue